import { render, staticRenderFns } from "./home-box3.vue?vue&type=template&id=2c2ab89f&scoped=true&"
import script from "./home-box3.vue?vue&type=script&lang=js&"
export * from "./home-box3.vue?vue&type=script&lang=js&"
import style0 from "./home-box3.vue?vue&type=style&index=0&id=2c2ab89f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2ab89f",
  null
  
)

export default component.exports